import { IconButton, Button, Box, ButtonProps } from '@mui/material';
import { ReactNode } from 'react';

interface ResponsiveButtonProps {
    icon: ReactNode;
    label: string;
    onClick: () => void;
    color?: ButtonProps['color'];
    variant?: ButtonProps['variant'];
    disabled?: boolean;
}

const ResponsiveButton = ({
    icon,
    label,
    onClick,
    color = 'inherit',
    variant = 'outlined',
    disabled = false,
}: ResponsiveButtonProps) => (
    <Box
        component="span"
        sx={{
            '& .MuiIconButton-root': {
                display: 'inline-flex',
            },
            '& .MuiButton-root': {
                display: 'none',
            },
            '@media (min-width:800px)': {
                '& .MuiIconButton-root': {
                    display: 'none',
                },
                '& .MuiButton-root': {
                    display: 'inline-flex',
                },
            },
        }}
    >
        <IconButton size="small" color={color} onClick={onClick} title={label} disabled={disabled}>
            {icon}
        </IconButton>
        <Button
            size="small"
            variant={variant}
            color={color}
            startIcon={icon}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </Button>
    </Box>
);

export default ResponsiveButton;
